import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import * as React from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';
var FormFieldContext = /*#__PURE__*/React.createContext(null);
FormFieldContext.displayName = 'FormFieldContext';

var useFormFieldContext = function useFormFieldContext() {
  return (// might return null
    React.useContext(FormFieldContext)
  );
};

var useNonNullishFormFieldContext = function useNonNullishFormFieldContext() {
  return useNonNullishContext(FormFieldContext);
};

function useFormFieldProps(id) {
  var formFieldContext = useFormFieldContext();
  React.useEffect(function () {
    if (formFieldContext) {
      var setInputId = formFieldContext.setInputId;
      setInputId(id);
      return function () {
        return setInputId(undefined);
      };
    } // eslint-disable-next-line @typescript-eslint/no-empty-function


    return function () {};
  }, [formFieldContext, id]); // if we're not inside of a FormInput, we've got nothing to say

  if (formFieldContext === undefined || formFieldContext === null) {
    return {
      id: id
    };
  }

  var errorIds = formFieldContext.errorIds,
      helperIds = formFieldContext.helperIds;
  return {
    id: id,
    'aria-invalid': errorIds.size > 0,
    // TODO: having multiple ids for aria-errormessage doesn't appear to be valid and axe will complain
    'aria-errormessage': errorIds.size > 0 ? _toConsumableArray(errorIds).join(' ') : undefined,
    'aria-describedby': errorIds.size + helperIds.size > 0 ? [].concat(_toConsumableArray(helperIds), _toConsumableArray(errorIds)).join(' ') : undefined
  };
}

export { FormFieldContext, useFormFieldContext, useFormFieldProps, useNonNullishFormFieldContext };